import { VALIDATION_ERROR } from '@types';

/** A 422's `errors`, keyed by field, as `useValidation` shows them under each field. */
export const apiErrorsToValidationErrors = (errors: Record<string, string[]>): VALIDATION_ERROR[] => {
	return Object.entries(errors).map(([field, issues]) => ({ field, issues }));
}
